import { useEffect, useRef } from "react";

const MouseTrailPage = () => {
  const canvasRef = useRef(null);
  const mouse = useRef({ x: 0, y: 0 });
  const isDrawing = useRef(false);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    const resizeCanvas = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
      ctx.fillStyle = "black";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
    };

    resizeCanvas();

    window.addEventListener("resize", resizeCanvas);

    const mouseMoveHandler = (e) => {
      mouse.current.x = e.clientX;
      mouse.current.y = e.clientY;
      isDrawing.current = true;
    };

    window.addEventListener("mousemove", mouseMoveHandler);

    const animate = () => {
      ctx.fillStyle = "rgba(0, 0, 0, 0.03)";
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      if (isDrawing.current) {
        ctx.beginPath();
        ctx.arc(mouse.current.x, mouse.current.y, 20, 0, Math.PI * 2);
        ctx.fillStyle = "yellow";
        ctx.fill();

        ctx.beginPath();
        ctx.arc(mouse.current.x, mouse.current.y, 2, 0, Math.PI * 2);
        ctx.fillStyle = "white";
        ctx.fill();
      }

      requestAnimationFrame(animate);
    };

    animate();

    return () => {
      window.removeEventListener("resize", resizeCanvas);
      window.removeEventListener("mousemove", mouseMoveHandler);
    };
  }, []);

  return <canvas ref={canvasRef} className="fixed inset-0" />;
};

export default MouseTrailPage;
